import { useMutation, useQueryClient } from "@tanstack/react-query";

import TenantAPI from "../../api/TenantAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { newToastEvent } from "../../../utils/ToastUtil";

export type Action = "Create" | "Update" | "Delete";

interface IndexMutation {
  action: Action;
  moduleAPIName: string;
  tenantID: string;
  data: any;
  isSupportal?: boolean;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

const useCRUDIndex = () => {
  const queryClient = useQueryClient();

  const crudAction = useMutation({
    mutationFn: ({
      action,
      moduleAPIName,
      tenantID,
      isSupportal,
      data,
    }: IndexMutation) => {
      return TenantAPI.crudIndex(moduleAPIName, isSupportal ? tenantID : "", {
        ...data,
        action,
      });
    },
    onSuccess: (data, { onSuccess, tenantID, moduleAPIName }) => {
      queryClient.invalidateQueries({
        queryKey: [tenantID, moduleAPIName],
      });
      queryClient.invalidateQueries({
        queryKey: ["module", tenantID, moduleAPIName],
      });

      callFunctionIfExists(onSuccess);
      newToastEvent(
        "success",
        typeof data === "string" ? data : data.data?.message
      );
    },
    onError: (error, { onError }) => {
      const errorMessage = getErrorMessage(
        error,
        "An unknown error occurred. Please try again."
      );

      newToastEvent("error", errorMessage);
      onError && onError(errorMessage);
    },
  });

  return {
    crudIndexAction: crudAction.mutate,
    crudLoadingIndexAction: crudAction.isPending,
  };
};

export default useCRUDIndex;
